<template>
  <!-- 设置抽签方式 - 弹出框 -->
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.visible"
    append-to-body
    modal-append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    width="600px"
    v-loading="loading"
  >
    <div class="dialog-content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="drawType">
          <el-radio-group v-model="ruleForm.drawType">
                <el-radio :label="0">线上抽签</el-radio>
                <el-radio :label="1">线下抽签</el-radio>
              </el-radio-group>
        </el-form-item>
      </el-form>
      <p class="red">注：请谨慎选择抽签方式，提交后不允许再修改。</p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DrawTypeDialog',

  data() {
    const checkDrawType = (rule, value, callback) => {
      if (![0, 1].includes(value)) {
        callback(new Error('请选择抽签方式'));
      } else {
        callback();
      }
    };
    return {
      dialog: {
        title: '设置抽签方式',
        visible: false,
      },

      ruleForm: {
        drawType: null
      },

      rules: {
        drawType: [
          // { required: true, message: '请选择抽签方式', trigger: 'change' },
          { validator: checkDrawType, trigger: 'blur' }
        ],
      },

      loading: false
    }
  },

  methods: {
    open(formData) {
      this.dialog.visible = true
      this.ruleForm = {
        ...this.ruleForm,
        ...formData
      }
    },

    close() {
      this.ruleForm.drawType = null
      this.dialog.visible = false
    },

    valid() {
      let valid = false
      this.$refs.ruleForm.validate(v => valid = v)
      return valid
    },

    async handleSubmit() {
      if (!this.valid()) return

      try {
        this.loading = true
        const res = await this.$api.postDrawType(this.ruleForm.drawType)
        if (!res.data.meta.success) {
          throw new Error(res.data.meta.message)
        }
        this.$message({
          type: "success",
          message: '抽签方式设置成功！',
        })
        this.$emit('success', this.ruleForm)
      } catch(err) {
        console.error('postDrawType fail', err)
        this.$message({
          type: "error",
          message: err.message || "请求失败，请稍后重试~",
        });
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  text-align: center;
}
</style>